export const generateDriverColors = (numDrivers) => {
  const colors = [];
  for (let i = 0; i < numDrivers; i++) {
    const hue = (i * 137.5) % 360;
    const saturation = 70 + (i % 3) * 10;
    const lightness = 45 + (i % 2) * 10;
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }
  return colors;
};

const cross = (o, a, b) =>
  (a[1] - o[1]) * (b[0] - o[0]) - (a[0] - o[0]) * (b[1] - o[1]);

const simpleConvexHull = (points) => {
  if (points.length <= 3) return points;

  const sorted = points.slice().sort((a, b) => a[1] - b[1] || a[0] - b[0]);
  const lower = [];
  for (const point of sorted) {
    while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], point) <= 0) {
      lower.pop();
    }
    lower.push(point);
  }

  const upper = [];
  for (let i = sorted.length - 1; i >= 0; i--) {
    const point = sorted[i];
    while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], point) <= 0) {
      upper.pop();
    }
    upper.push(point);
  }

  upper.pop();
  lower.pop();
  return lower.concat(upper);
};

const createTripBasedZones = (driverZones) =>
  driverZones.map(({ driver, color, tripLocations }) => {
    if (tripLocations.length < 3) {
      const centroidLat =
        tripLocations.reduce((sum, point) => sum + point[0], 0) / tripLocations.length;
      const centroidLng =
        tripLocations.reduce((sum, point) => sum + point[1], 0) / tripLocations.length;

      return {
        driverId: driver.driver_id,
        driverName: driver.driver_name,
        color,
        center: [centroidLat, centroidLng],
        radius: 4200,
        isPolygon: false,
        points: tripLocations,
      };
    }

    const hullPoints = simpleConvexHull(tripLocations);
    if (hullPoints.length < 3) {
      const centroidLat =
        tripLocations.reduce((sum, point) => sum + point[0], 0) / tripLocations.length;
      const centroidLng =
        tripLocations.reduce((sum, point) => sum + point[1], 0) / tripLocations.length;

      return {
        driverId: driver.driver_id,
        driverName: driver.driver_name,
        color,
        center: [centroidLat, centroidLng],
        radius: 4200,
        isPolygon: false,
        points: tripLocations,
      };
    }

    return {
      driverId: driver.driver_id,
      driverName: driver.driver_name,
      color,
      polygon: hullPoints,
      isPolygon: true,
      center: null,
      points: tripLocations,
    };
  });

export const generateDriverZones = (driversWithTrips) => {
  const driverColors = generateDriverColors(driversWithTrips.length);

  const driverZones = driversWithTrips
    .map((driver, index) => {
      const tripLocations = [];

      driver.trips?.forEach((trip) => {
        const pickupLat = trip.pickup_lat || trip.origin?.latitude;
        const pickupLng = trip.pickup_lng || trip.origin?.longitude;
        const dropoffLat = trip.dropoff_lat || trip.destination?.latitude;
        const dropoffLng = trip.dropoff_lng || trip.destination?.longitude;

        if (pickupLat && pickupLng) tripLocations.push([pickupLat, pickupLng]);
        if (dropoffLat && dropoffLng) tripLocations.push([dropoffLat, dropoffLng]);
      });

      const driverLat = driver.current_latitude || driver.ref_latitude;
      const driverLng = driver.current_longitude || driver.ref_longitude;
      if (driverLat && driverLng) tripLocations.push([driverLat, driverLng]);

      if (tripLocations.length === 0) return null;

      return {
        driver,
        index,
        color: driverColors[index],
        tripLocations,
      };
    })
    .filter(Boolean);

  return createTripBasedZones(driverZones);
};
